import {
  CollectionEntryProjectFieldsFragmentDoc,
  isType,
} from '@spotify/confidence-graphql';
import { createCollectionEntryExtension } from '@spotify/plugin-confidence-collections-react';

import { projectsPlugin } from '../plugin';
import { projectRouteRef } from '../routes';

export const ProjectCollectionEntryExtension = projectsPlugin.provide(
  createCollectionEntryExtension({
    id: 'project',
    resourceType: 'Project',
    routeRef: projectRouteRef,
    fragment: CollectionEntryProjectFieldsFragmentDoc,
    predicate: ({ resource }) => isType(resource, 'CollaborationV1Project'),
    render: () => null,
  }),
);
